<template>
  <svg
    width="20"
    height="20"
    viewBox="2.85 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_105_7888"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_105_7888)">
      <path
        d="M15.8848 5.37858C16.4076 6.16095 16.4076 7.25007 16.4076 9.42832C16.4076 11.6066 16.4076 12.6957 15.8848 13.4781C15.6585 13.8168 15.3677 14.1076 15.029 14.3339C14.3455 14.7906 13.428 14.8483 11.7547 14.8556V14.8566L10.8974 16.5713C10.6116 17.1429 9.79597 17.1429 9.51019 16.5713L8.65285 14.8566V14.8556C6.9796 14.8483 6.06204 14.7906 5.37858 14.3339C5.03988 14.1076 4.74907 13.8168 4.52276 13.4781C4 12.6957 4 11.6066 4 9.42832C4 7.25007 4 6.16095 4.52276 5.37858C4.74907 5.03988 5.03988 4.74907 5.37858 4.52276C6.16095 4 7.25007 4 9.42832 4H10.9793C13.1575 4 14.2466 4 15.029 4.52276C15.3677 4.74907 15.6585 5.03988 15.8848 5.37858Z"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="stroke"
      />
      <path
        d="M8.37891 7.875L13.0318 7.875"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="stroke"
      />
      <path
        d="M9.47363 10.9766H11.8001"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="stroke"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.v-list-item--active svg .fill {
  fill: #437be8;
}
.v-list-item--active svg .stroke {
  stroke: #437be8;
}
</style>
